import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@auto-editor/environment';
import { BasicCustomerNameDto, QuestionnaireListDto } from '@auto-editor/shared/models';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataQuestionnaireService {
  customerSelected: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private http: HttpClient) {}

  getQuestionnaireList(idClient: string): Observable<QuestionnaireListDto[]> {
    return this.http.get<QuestionnaireListDto[]>(`${environment.serverBackend}/survey`, {
      params: {
        customerId: idClient
      }
    });
  }

  getQuestionnaireById(questionnaireId: string): Observable<QuestionnaireListDto> {
    return this.http.get<QuestionnaireListDto>(`${environment.serverBackend}/survey/${questionnaireId}`);
  }

  postQuestionnaire(body: any) {
    return this.http.post(`${environment.serverBackend}/survey`, body);
  }

  updateQuestionnaire(body: any, surveyModified: boolean) {
    return this.http.put(`${environment.serverBackend}/survey`, body, {
      params: {
        modifySurvey: surveyModified
      }
    });
  }

  deleteQuestionnaire(questionnaireId: string) {
    return this.http.delete(`${environment.serverBackend}/survey/${questionnaireId}`);
  }

  uploadImage(questionnaireId: string, image: unknown): Observable<string> {
    return this.http.patch<string>(`${environment.serverBackend}/survey/${questionnaireId}/image`, image);
  }

  renameQuestionnaire(newName: string, qnId: string) {
    return this.http.patch(`${environment.serverBackend}/survey/${qnId}/rename`, { name: newName }); //TODO: falta añadir el endpoint de back
  }

  getClientList(): Observable<BasicCustomerNameDto[]> {
    return this.http.get<BasicCustomerNameDto[]>(`${environment.serverBackend}/customer/access`);
  }

  cloneQuestionnaire(qnId: string, newName: string, customerId: string) {
    return this.http.post(`${environment.serverBackend}/survey/clone`, {
      surveyId: qnId,
      name: newName,
      customerId: customerId
    });
  }

  publishQuestionnaire(qnId: string) {
    return this.http.post(`${environment.serverBackend}/survey/${qnId}/publish`, {});
  }

  recoverQuestionnaire(qnId: string) {
    return this.http.patch(`${environment.serverBackend}/survey/${qnId}/recover`, {});
  }

  closeQuestionnaire(qnId: string) {
    return this.http.patch(`${environment.serverBackend}/survey/${qnId}/close`, {});
  }

  enableQuestionnaire(qnId: string) {
    return this.http.patch(`${environment.serverBackend}/survey/${qnId}/enable`, {});
  }

  archiveQuestionnaire(qnId: string) {
    return this.http.patch(`${environment.serverBackend}/survey/${qnId}/archive`, {});
  }

  linksQuestionnaire(qnId: string) {
    return this.http.get(`${environment.serverBackend}/survey/${qnId}/share`);
  }
}
